interface StatusBadgeProps {
    status: 'draft' | 'published';
}

export default function StatusBadge({ status }: StatusBadgeProps) {
    const baseClasses = "px-2 py-1 text-xs font-medium rounded-full";

    if (status === 'published') {
        return <span className={`${baseClasses} bg-green-100 text-green-800`}>Published</span>;
    }

    return <span className={`${baseClasses} bg-yellow-100 text-yellow-800`}>Draft</span>;
} 